import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Location, Share, Success } from '../../assests/ExportImageIcon'

// Show the exact amount the API returned — never round it away.
const formatRupees = (value) => {
    const amount = Number(value)
    if (Number.isNaN(amount)) return '—'
    return `₹${amount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

const formatScheduleDate = (schedule) => {
    if (!schedule?.event_date) return '—'
    const date = new Date(`${schedule.event_date}T00:00:00`)
    if (Number.isNaN(date.getTime())) return schedule.event_date
    return date.toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })
}

const formatTime = (value) => {
    if (!value) return '—'
    const [hh, mm] = value.split(':')
    const hour = Number(hh)
    const period = hour >= 12 ? 'PM' : 'AM'
    const displayHour = ((hour + 11) % 12) + 1
    return `${displayHour}:${mm} ${period}`
}

const formatPaidAt = (iso) => {
    if (!iso) return '—'
    const date = new Date(iso)
    if (Number.isNaN(date.getTime())) return iso
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
}

const IMPORTANT_INFO = [
    'Carry a valid government-issued photo ID matching the guest details',
    'Arrive at least 30 minutes before the scheduled start time',
    'Booking confirmation and e-tickets will be sent via email, SMS and WhatsApp',
]

const EventBookingConfirm = () => {
    const navigate = useNavigate()
    const event = useSelector((state) => state.eventBooking.selectedEvent)
    const bookingGuests = useSelector((state) => state.eventBooking.bookingGuests)
    const confirmation = useSelector((state) => state.eventBooking.bookingConfirmation)

    if (!confirmation) {
        return (
            <section className='bookingConfirm commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <p>No confirmed event booking found.</p>
                    <button type='button' className='commonBtn' onClick={() => navigate('/event-booking')}>
                        Browse Events
                    </button>
                </div>
            </section>
        )
    }

    const venue = event?.event_venues?.[0]
    const schedule = confirmation.schedule
    const items = confirmation.items || []
    const paymentSummary = confirmation.payment_summary
    const guests = bookingGuests || []
    const intentStatus = confirmation.paymentIntent?.status

    return (
        <>
            <section className='bookingConfirm commonTopPadding commonBottomPadding'>
                <div className='container'>
                    <div className='row g-4'>
                        <div className='col-md-12'>
                            <div className='bookingTextConfirm'>
                                <img src={Success} alt="" />
                                <div className='bookingHead commonGredientText'>Booking Confirmed</div>
                                <p>Your Event has been successfully booked</p>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='bookingConfirmInner'>
                                <div className='resultCard'>
                                    <div className='bookingConfirmMetaLabel'>
                                        Booking ID <strong>{confirmation.confirmation_code || (confirmation.booking_id ? `#${confirmation.booking_id}` : '—')}</strong>
                                    </div>

                                    <div className='hotelInfoCard__top mt-3'>
                                        <div>
                                            <div className='hotelInfoCard__name'>{event?.name || confirmation.event?.name}</div>
                                            {venue && (
                                                <div className='hotelCard__dateTime'>
                                                    <img src={Location} alt="" /> {venue.venue_name}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className='bookingSegmentBox bookingInfoRow'>
                                        <div>
                                            <div className='bookingInfoLabel'>DATE</div>
                                            <div className='bookingInfoDate'>{formatScheduleDate(schedule)}</div>
                                        </div>
                                        <div>
                                            <div className='bookingInfoLabel'>TIME</div>
                                            <div className='bookingInfoDate'>{formatTime(schedule?.start_time)}</div>
                                        </div>
                                        <div className='text-end'>
                                            <div className='bookingInfoLabel'>TICKETS</div>
                                            <div className='bookingInfoDate'>
                                                {items.length ? items.map((item) => `${item.ticket_name} × ${item.quantity}`).join(', ') : '—'}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='bookingConfirmActions'>
                                        <button
                                            type='button'
                                            className='bookingDownloadBtn'
                                            onClick={() => navigate('/profile', { state: { section: 'events' } })}
                                        >
                                            View Booking
                                        </button>
                                        <button type='button' className='bookingShareBtn' aria-label="Share">
                                            <img src={Share} alt="" />
                                        </button>
                                    </div>

                                    <button
                                        type='button'
                                        className='commonBtnTransparent w-100 mt-2'
                                        onClick={() => navigate('/profile', { state: { section: 'create-group' } })}
                                    >
                                        Create Splitwise Group
                                    </button>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Guest Details</div>
                                    <div className='bsBox'>
                                        {guests.length ? guests.map((guest, index) => (
                                            <div className='bookingGuestCard' key={index}>
                                                <span className='bookingPassengerType'>GUEST {index + 1}</span>
                                                <div className='bookingGuestGrid'>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Guest Name:</div>
                                                        <div className='bookingPassengerDetail'>{[guest.first_name, guest.last_name].filter(Boolean).join(' ')}</div>
                                                    </div>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Email:</div>
                                                        <div className='bookingPassengerDetail'>{guest.email || '—'}</div>
                                                    </div>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Phone Number:</div>
                                                        <div className='bookingPassengerDetail'>{guest.phone_number || guest.phone || '—'}</div>
                                                    </div>
                                                    <div>
                                                        <div className='bookingConfirmMetaLabel'>Gender:</div>
                                                        <div className='bookingPassengerDetail'>{guest.gender || '—'}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        )) : (
                                            <p className='bsFareNote'>Guest details unavailable</p>
                                        )}
                                    </div>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Confirmation Sent</div>
                                    <div className='bsBox'>
                                        <p className='bookingConfirmSentText'>
                                            {intentStatus === 'succeeded'
                                                ? "We've sent your booking confirmation via email, SMS and WhatsApp."
                                                : 'Your payment is being processed. Booking confirmation will be sent via email, SMS and WhatsApp once confirmed.'}
                                        </p>
                                    </div>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Payment Details</div>
                                    <div className='bsBox'>
                                        {paymentSummary ? (
                                            <>
                                                <div className='bsFareRow'>
                                                    <span>Net Amount</span>
                                                    <span>{formatRupees(paymentSummary.net_amount)}</span>
                                                </div>
                                                <div className='bsFareRow'>
                                                    <span>Taxes &amp; Fees</span>
                                                    <span>{formatRupees(paymentSummary.taxes_and_fees)}</span>
                                                </div>
                                                <div className='bsFareRow'>
                                                    <span>Convenience Fee</span>
                                                    <span>{formatRupees(paymentSummary.convenience_fee)}</span>
                                                </div>
                                                {Number(paymentSummary.discount_amount) > 0 && (
                                                    <div className='bsFareRow bookingDiscountRow'>
                                                        <span>Discount Applied</span>
                                                        <span>-{formatRupees(paymentSummary.discount_amount)}</span>
                                                    </div>
                                                )}
                                                <div className='bsFareDivider' />
                                                <div className='bsFareRow bsFareRow--total'>
                                                    <span>TOTAL AMOUNT</span>
                                                    <span>{formatRupees(paymentSummary.total_amount)}</span>
                                                </div>
                                            </>
                                        ) : (
                                            <p className='bsFareNote'>Payment details unavailable</p>
                                        )}
                                        <div className='bsFareDivider' />
                                        <div className='bsFareRow'>
                                            <span>Payment Method</span>
                                            <span>Stripe (Card)</span>
                                        </div>
                                        <div className='bsFareRow'>
                                            <span>Transaction ID</span>
                                            <span>{confirmation.payment_intent_id || '—'}</span>
                                        </div>
                                        <div className='bsFareRow'>
                                            <span>Payment Date</span>
                                            <span>{formatPaidAt(confirmation.paidAt)}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='bsSection'>
                                    <div className='bsSectionTitle'>Important Information</div>
                                    <div className='bsBox'>
                                        <ul className='bsInfoList'>
                                            {IMPORTANT_INFO.map((info, index) => (
                                                <li key={index}>{info}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
        </>
    )
}

export default EventBookingConfirm
